module.exports = __webpack_public_path__ + "static/media/Violin.e8158584.svg";